import React, { useEffect, useState } from "react";
import {
  Input,
  Button,
  Dropdown,
  Menu,
  Avatar,
  Row,
  Col,
  Badge,
  Select,
} from "antd";
import {
  DownOutlined,
  ShoppingCartOutlined,
  UserOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCountry,
  setCountryName,
  SEARCH_RESULTS,
} from "../../../store/actions/homepageActions";
import "./Navbar.css";

const { Option } = Select;
const { Search } = Input;

const Navbar = () => {
  const [searchValue, setSearchValue] = useState("");
  const [country, setCountry] = useState(
    localStorage.getItem("Country") || "USA"
  );

  const blogData = useSelector((state) => state.home.getAllBlogs) || [];
  const productsData =
    useSelector((state) => state.home.productsDataArrays) || [];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!localStorage.getItem("Country")) {
      dispatch(getCountry());
    }
  }, [dispatch]);

  const handleCountryChange = (value) => {
    localStorage.setItem("Country", value);
    setCountry(value);
    dispatch(setCountryName(value));
    navigate("/");
    window.location.reload();
  };

  const handleSearch = (value = "") => {
    const pathname = window.location.pathname;
    if (searchValue?.length > 3) {
      if (pathname.includes("/blogs") && searchValue?.length >= 3) {
        const results = blogData.filter((el) =>
          el.data.title.toLowerCase().includes(searchValue.toLowerCase())
        );
        dispatch({ type: SEARCH_RESULTS, payload: results });
      } else {
        const results = productsData.filter((el) =>
          el.title.toLowerCase().includes(searchValue.toLowerCase())
        );
        dispatch({ type: SEARCH_RESULTS, payload: results });
      }
    } else if (pathname.includes("/blogs") && searchValue?.length < 3) {
      // const results = blogData.filter((el) =>
      //   el.data.title.toLowerCase().includes(searchValue.toLowerCase())
      // );
      dispatch({ type: SEARCH_RESULTS, payload: blogData });
    } else {
      // const results = productsData.filter((el) =>
      //   el.title.toLowerCase().includes(searchValue.toLowerCase())
      // );
      dispatch({ type: SEARCH_RESULTS, payload: productsData });
    }
  };
  useEffect(() => {
    handleSearch();

    // return () => {
    //   second;
    // };
  }, [searchValue]);

  const moreMenu = (
    <Menu>
      <Menu.Item key="1">Notification Preferences</Menu.Item>
      <Menu.Item key="2">Customer Care</Menu.Item>
      <Menu.Item key="3">Advertise</Menu.Item>
      <Menu.Item key="4">Download App</Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ecron-navbar">
        <Row justify="space-between" align="middle" className="navbar-row">
          {/* Logo */}
          <Col xs={24} sm={4} className="navbar-logo">
            <Link to="/">
              <span className="logo-text">ECRON HUB</span>
            </Link>
          </Col>

          {/* Search Bar */}
          <Col xs={24} sm={8} className="navbar-search">
            <Search
              placeholder="Search for products, brands and more"
              enterButton={<SearchOutlined />}
              onSearch={handleSearch}
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
              className="search-input"
            />
          </Col>

          {/* Country Selector */}
          <Col xs={12} sm={3} className="navbar-country">
            <Select
              value={country}
              onChange={handleCountryChange}
              className="country-select"
              size="middle"
            >
              <Option value="USA">Country-USA</Option>
              <Option value="India">Country-India</Option>
            </Select>
          </Col>

          {/* Login Button */}
          <Col xs={12} sm={3} className="navbar-login">
            <Button
              type="text"
              icon={<UserOutlined />}
              className="nav-btn"
              disabled
            >
              Login
            </Button>
          </Col>

          {/* More Dropdown */}
          <Col xs={12} sm={3} className="navbar-more">
            <Dropdown
              overlay={moreMenu}
              placement="bottomCenter"
              arrow
              disabled
            >
              <Button type="text" className="nav-btn">
                More <DownOutlined />
              </Button>
            </Dropdown>
          </Col>

          {/* Cart Icon */}
          <Col xs={12} sm={3} className="navbar-cart">
            <Badge count={2} size="small">
              <Link to="/">
                <Button
                  type="text"
                  icon={<ShoppingCartOutlined />}
                  className="nav-btn"
                  disabled
                >
                  Cart
                </Button>
              </Link>
            </Badge>
          </Col>
        </Row>
      </div>
      <Menu
        mode="horizontal"
        //className="header-bar"
        theme="dark"
        style={{ alignContent: "center" }}
      >
        <Menu.Item key="1" className="page-select">
          <NavLink to="/electronics">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;
            <strong>Electronics</strong>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="2">
          <NavLink to="/projectors">
            <strong>Projectors </strong>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="3">
          <NavLink to="/oled-tv">
            <strong>OLED TVs</strong>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="4">
          <NavLink to="/appliances">
            <strong>HOME APPLIANCES</strong>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="5">
          <NavLink to="/car-accessories">
            <strong>CAR ACCESSSORIES</strong>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="6">
          <NavLink to="/blogs">
            <strong>ARTICLES</strong>
          </NavLink>
        </Menu.Item>
        {/* <Menu.Item key="7">
                <NavLink to="/json-to-xml">
                  <strong>TOOLS</strong>
                </NavLink>
              </Menu.Item> */}
        {/* <Menu.Item key="8">
                <NavLink to="/home-loan-calculator">
                  <strong>EMI CLAC</strong>
                </NavLink>
              </Menu.Item> */}
      </Menu>
    </>
  );
};

export default Navbar;
